import { PropsWithChildren, ReactNode } from 'react';
import ConditionalRenderer from '../ui/custom/ConditionalRenderer';

export type WorkspaceHeaderProps = {
  title: ReactNode;
  subtitle: string;
  description?: string;
};

type WorkspaceHeaderSubtitleProps = PropsWithChildren<{
  subtitle: string;
}>;

const Base = ({ children }: PropsWithChildren) => (
  <div className="flex flex-col gap-2">{children}</div>
);

const Title = ({ children }: PropsWithChildren) => (
  <h4 className="text-sm! mb-0 mt-0! text-primary font-semibold leading-5">
    {children}
  </h4>
);

const Subtitle = ({ subtitle, children }: WorkspaceHeaderSubtitleProps) => (
  <div className="flex gap-4 items-center">
    <h2 className="text-2xl font-medium text-base-content leading-8">
      {subtitle}
    </h2>
    {children}
  </div>
);

const Description = ({ children }: PropsWithChildren) => (
  <p className="text-base text-base-content leading-7">{children}</p>
);

Base.displayName = 'WorkspaceHeader';
Title.displayName = 'WorkspaceHeader.Title';
Subtitle.displayName = 'WorkspaceHeader.Subtitle';
Description.displayName = 'WorkspaceHeader.Description';

export const WorkspaceHeader = Object.assign(Base, {
  Title,
  Subtitle,
  Description,
});

export default function WorkspaceHeaderBuilder({
  title,
  subtitle,
  description,
}: WorkspaceHeaderProps) {
  return (
    <WorkspaceHeader>
      <WorkspaceHeader.Title>{title}</WorkspaceHeader.Title>
      <WorkspaceHeader.Subtitle subtitle={subtitle} />
      <ConditionalRenderer condition={!!description}>
        <WorkspaceHeader.Description>{description}</WorkspaceHeader.Description>
      </ConditionalRenderer>
    </WorkspaceHeader>
  );
}
